import React from 'react';
import PropTypes from 'prop-types';

import AddControl from 'components/add_control';
import Approver from './approver';
import ManagedInput from 'components/form/managed_input';

import { connect } from 'react-redux';
import { addAssignee as addApprover, changeAssigneeGroup as changeApproverGroup } from './store/workflow/actions';
import { modes } from './helper';

const ApproverGroup = ({
  addApprover,
  approverGroup,
  changeApproverGroup,
  step,
}) => {
  const handleAddApprover = () => {
    addApprover(step, approverGroup);
  };

  const handleModeChange = (mode) => {
    changeApproverGroup(step, approverGroup, { mode });
  };

  return (
    <div className="approver-group mb-3 pb-3">
      <div className="approver-group-info">
        <b className="mb-3">Approver Group {approverGroup.index + 1}</b>
        <ManagedInput
          options={modes}
          type="radioGroup"
          value={approverGroup.mode}
          onValueChange={handleModeChange}
        />
      </div>

      <div className="approver-group-list">
        {approverGroup.assignees.map((approver) => {
          return (
            <Approver
              approver={approver}
              approverGroup={approverGroup}
              key={approver.key}
              step={step}
            />
          );
        })}
        <AddControl aria-label="add-approver" onClick={handleAddApprover}>Add Approver</AddControl>
      </div>
    </div>
  );
};

ApproverGroup.propTypes = {
  addApprover: PropTypes.func.isRequired,
  approverGroup: PropTypes.shape({
    assignees: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string.isRequired
    })).isRequired,
    index: PropTypes.number.isRequired,
    mode: PropTypes.oneOf(['and_condition', 'or_condition']).isRequired
  }).isRequired,
  changeApproverGroup: PropTypes.func.isRequired,
  step: PropTypes.object.isRequired
};

const mapDispatchToProps = {
  addApprover,
  changeApproverGroup,
};

export default connect(null, mapDispatchToProps)(ApproverGroup);
